import React from "react";
import Timesheet from "./components/TimeSheet";
 
const App = () => {
  return <Timesheet />;
};
 
export default App;
